"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILED = exports.SUCCEEDED = exports.STARTED = exports.UNINITIALIZED = void 0;
var UNINITIALIZED = 'UNINITIALIZED';
exports.UNINITIALIZED = UNINITIALIZED;
var STARTED = 'STARTED';
exports.STARTED = STARTED;
var SUCCEEDED = 'SUCCEEDED';
exports.SUCCEEDED = SUCCEEDED;
var FAILED = 'FAILED';
exports.FAILED = FAILED;